var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessPendingPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 392.574 392.574",
    style: {
      enableBackground: "new 0 0 392.574 392.574"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M389.366,130.61l-85.592-85.592c-4.073-4.073-10.731-4.267-15.063-0.388l-33.939,30.901 l-73.115-33.293c-21.915-9.956-48.291-0.453-58.699,21.269l-38.141,79.192H33.358C14.998,142.699,0,157.697,0,176.056v144.873 c0,18.36,14.998,33.358,33.358,33.358h201.374c18.36,0,33.358-14.998,33.358-33.358v-51.911L389.43,145.931 C393.632,141.664,393.632,134.812,389.366,130.61z M246.238,320.929c0,6.4-5.172,11.572-11.572,11.572H33.358 c-6.4,0-11.572-5.172-11.572-11.572V176.056c0-6.4,5.172-11.572,11.572-11.572H77.77c-0.517,13.446,6.077,26.57,18.36,33.939 c19.071,11.507,44.024,3.232,53.075-14.61l10.343-19.329h75.055c6.4,0,11.572,5.172,11.572,11.572L246.238,320.929L246.238,320.929z  M171.378,142.634l5.107-9.438c1.228-2.327,3.232-2.909,4.396-3.103c1.099-0.129,3.232-0.129,5.107,1.681l10.925,10.861H171.378z  M234.731,142.634h-7.046l-26.376-26.246c-6.271-6.271-14.933-9.115-23.725-7.822c-8.792,1.293-16.226,6.465-20.428,14.352 l-27.152,50.554c-5.107,7.952-13.964,11.055-22.626,6.271c-7.176-4.331-9.891-13.382-6.271-20.945l41.503-85.851 c5.301-11.119,18.877-15.968,30.061-10.925l77.834,35.491l78.481,78.481l-60.962,61.931v-61.867 C268.024,157.632,253.156,142.634,234.731,142.634z M344.372,160.606l-71.758-71.693l23.079-21.01l70.529,70.465L344.372,160.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M234.731,164.549h-74.99l-10.343,19.329c-8.986,17.842-34.004,26.117-53.075,14.61 c-12.283-7.37-18.941-20.493-18.36-33.939H33.358c-6.4,0-11.572,5.172-11.572,11.572v144.873c0,6.4,5.172,11.572,11.572,11.572 h201.374c6.4,0,11.572-5.172,11.572-11.572V176.056C246.238,169.721,241.067,164.549,234.731,164.549z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC10D"
    },
    points: "272.614,88.784 344.372,160.606 366.287,138.367 295.693,67.773  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M101.236,158.796c-3.62,7.564-1.034,16.614,6.271,20.945c8.598,4.784,17.519,1.745,22.626-6.271 l27.152-50.554c4.202-7.822,11.636-13.059,20.428-14.352c8.792-1.293,17.39,1.552,23.725,7.822l26.376,26.246h7.046 c18.36,0,33.358,14.998,33.358,33.358v61.867l60.962-61.867l-78.675-78.481L172.671,62.02c-11.184-5.107-24.63-0.259-30.061,10.925 L101.236,158.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M61.737,296.816H50.683c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h11.055c6.012,0,10.925-4.848,10.925-10.925S67.749,296.816,61.737,296.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M113.648,296.816h-11.055c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h11.055c6.012,0,10.925-4.848,10.925-10.925C124.574,301.664,119.661,296.816,113.648,296.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M165.495,296.816H154.44c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h11.055c6.012,0,10.925-4.848,10.925-10.925S171.572,296.816,165.495,296.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M217.471,296.816h-11.055c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h11.055c6.012,0,10.925-4.848,10.925-10.925S223.483,296.816,217.471,296.816z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.608,
    y: 232.622,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.105,
    height: 20.105
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M92.574,210.836H50.683c-6.012,0-10.925,4.848-10.925,10.925v41.956 c0,6.012,4.848,10.925,10.925,10.925h41.956c6.012,0,10.925-4.848,10.925-10.925v-41.956 C103.434,215.685,98.586,210.836,92.574,210.836z M81.648,252.792h-20.04v-20.105h20.105v20.105H81.648z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPendingPayment);
export default __webpack_public_path__ + "static/media/BusinessPendingPayment.a5a95160d81e720ad4000d87eee2b137.svg";
export { ForwardRef as ReactComponent };